import './NotFound.css';
import notFund from "../../assets/lottie/notFund.json";
import notAccess from "../../assets/lottie/notAccess.json";
import connecting from "../../assets/lottie/connecting.json"
import * as React from "react";
import {Player} from "@lottiefiles/react-lottie-player";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {css} from "@emotion/css";
import {doUserLoginOut} from "../Sidebar/LogOut";
import {useNavigate} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";


const ErrorPage = (
    {
        errorType = ErrorType.CONNECTING,
        title = "هیچ اطلاعاتی برای نمایش وجود ندارد!",
        subTitle = "در جستجو از عبارت های متداول تر استفاده نمایید یا تعدادی از فیلتر ها را حذف نمایید.",
        fullPage = false
    }) => {

    const navigate = useNavigate()
    const {role: roles} = useAuthState();
    let authDispatcher = useAuthDispatcher();
    let addressTitle = roles.length > 0 ? "صفحـه اصلـی" : "خروج از سامانه";

    function handleDoAction() {
        if (roles.length > 0) {
            navigate(RouteInfo.Dashboard.globalUrl)
        } else {
            doUserLoginOut(authDispatcher, navigate)
        }
    }

    return (
        <section className={`${fullPage ? "not-found-container-full-page-style" : "w-100 h-100"}`}>
            <section className={`not-found-container`}>
                <Player
                    src={errorType}
                    loop
                    autoplay
                    style={{height: '200px', width: '200px'}}
                />
                <span className="not-found-title">
                    {title}
                </span>
                <span className="not-found-sub-title">
                    {subTitle}
                </span>
                {errorType === ErrorType.NOT_ACCESS &&
                    <ButtonPrimaryRaiko
                        className={css`margin-top: 1rem !important;`}
                        label={addressTitle}
                        onClick={handleDoAction}/>
                }
            </section>
        </section>

    )
}
export default ErrorPage


export const ErrorType = {
    "NOT_FOUND": notFund,
    "NOT_ACCESS": notAccess,
    "CONNECTING": connecting,
}